import { ScrollToTop } from './components/ScrollToTop'
import './App.css'
// core styles
// core styles
import HomeRoute from './Routes/HomeRoute';
import { useEffect } from 'react';
function App() {
  useEffect(() => {
    localStorage.removeItem('activeMenu');
  }, []);
  return (
    <>
      <ScrollToTop />
      <HomeRoute />
    </>
  )
}

export default App
